import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
export default function TermsandConditions() {
  return (
  <>
   <div className="py-5" style={{ backgroundColor: "#f8f9fa", marginTop:"6rem", minHeight: "100vh" }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} md={12}>
            <div className="bg-white p-4 p-md-5 rounded shadow">
              <h1 className="mb-4 text-center">General Policy V Hotel The Grand Shoba</h1>

              <h5>1. General Policy</h5>
              <p>
                We understand that plans can change. This Cancellation & Refund Policy outlines the terms under which guests can cancel their bookings and receive refunds.
              </p>
              <p>By making a reservation through our website, you agree to the terms stated below.</p>

              <h5 className="mt-4">2. Cancellation Terms</h5>
              <ul>
                <li><strong>Free Cancellation:</strong> Cancellations made 24 hours or more before the check-in date are eligible for a full refund.</li>
                <li><strong>Late Cancellation:</strong> Cancellations made less than 24 hours before the check-in date will be charged one night’s room rate as a cancellation fee.</li>
                <li><strong>No-Show:</strong> Guests who do not check in without cancelling will be charged 100% of the booking amount. No refunds will be issued.</li>
                <li><strong>Group Bookings:</strong> For group or bulk bookings (more than 3 rooms), cancellations must be made at least 72 hours prior to check-in for a full refund. Otherwise, one night’s charge per room will apply.</li>
              </ul>

              <h5 className="mt-4">3. Modification of Bookings</h5>
              <ul>
                <li>Booking date changes are allowed up to 24 hours before check-in, subject to availability.</li>
                <li>Tariff differences (if any) will be applicable during rescheduling.</li>
              </ul>

              <h5 className="mt-4">4. Refund Process</h5>
              <ul>
                <li>Refunds will be processed only to the original payment method used during booking.</li>
                <li>Refunds for eligible cancellations will be initiated within 3–5 business days.</li>
                <li>Depending on your bank/payment provider, it may take 7–10 business days for the refund to reflect in your account.</li>
              </ul>

              <h5 className="mt-4">5. Payment Gateway</h5>
              <p>All online transactions are processed securely via Razorpay.</p>
              <p>V Hotel The Grand Shoba is not responsible for delays or technical errors caused by Razorpay or associated banking partners.</p>

              <h5 className="mt-4">6. Force Majeure</h5>
              <p>No refunds or compensation will be provided for cancellations due to circumstances beyond our control (e.g., natural disasters, government orders, pandemics, etc.).</p>

              <h5 className="mt-4">7. How to Cancel</h5>
              <p>
                To cancel a booking, please contact us with your booking reference number:
              </p>
              <p>
                📧 Email: <a href="mailto:info@vhotelthegrandshoba.com">booking@vhotelthegrandshoba.com</a><br />
                📞 Phone: <a href="tel:+919811320209">+91 9811320209</a>, <a href="tel:+919811226576">+91 9811226576</a>
              </p>

              <h5 className="mt-4">8. Contact</h5>
              <p>
                For any issues or assistance related to cancellations and refunds, please reach out:
              </p>
              <p>
                📧 Email: <a href="mailto:info@vhotelthegrandshoba.com">info@vhotelthegrandshoba.com</a><br />
                📞 Phone: <a href="tel:+919811320209">+91 9811320209</a>, <a href="tel:+919811226576">+91 9811226576</a>
              </p>
                  <p className="mt-4 text-muted text-center">
                Last updated: May 2025
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  
  </>
  )
}
